export const arrow_up_left = () => (
  <path
    d="M17 17L7 7m0 0v10M7 7h10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
